var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 16.6654C4.375 16.3202 4.65482 16.0404 5 16.0404L15 16.0404C15.3452 16.0404 15.625 16.3202 15.625 16.6654C15.625 17.0105 15.3452 17.2904 15 17.2904L5 17.2904C4.65482 17.2904 4.375 17.0105 4.375 16.6654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 2.89009C9.80214 2.64601 10.1979 2.64601 10.4419 2.89009L13.3586 5.80676C13.6027 6.05083 13.6027 6.44656 13.3586 6.69064C13.1145 6.93472 12.7188 6.93472 12.4747 6.69064L10.625 4.84091V13.332C10.625 13.6772 10.3452 13.957 10 13.957C9.65482 13.957 9.375 13.6772 9.375 13.332V4.84091L7.52527 6.69064C7.2812 6.93472 6.88547 6.93472 6.64139 6.69064C6.39731 6.44656 6.39731 6.05083 6.64139 5.80676L9.55806 2.89009Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5ca80684a2b322a703e25038d72022da.svg";
export { ForwardRef as ReactComponent };